import React from 'react';
import Icon from '../../../components/AppIcon';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const CouponStats = ({ stats }) => {

  const {t} = useTranslation();

  const { statistics } = useSelector((state) => state.general);
  const {  metaDiscountCode } = useSelector(
    (state) => state.general
  );

  const statCards = [
    {
      title: "total_coupons",
      value: metaDiscountCode?.total,
      icon: 'Ticket',
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'active_coupons',
      value: statistics?.active_coupons,
      icon: 'CheckCircle',
      color: 'text-success',
      bgColor: 'bg-success/10',
      change: '+8%',
      changeType: 'positive'
    },
    {
      title: 'total_usage',
      value: statistics?.used_coupons,
      icon: 'TrendingUp',
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      change: '+24%',
      changeType: 'positive'
    },
    {
      title: 'expired_usage',
      value: statistics?.expired_coupons,
      icon: 'Clock',
      color: 'text-error',
      bgColor: 'bg-error/10',
      change: '-5%',
      changeType: 'negative'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
      {statCards?.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-lg border border-border shadow-elevation-1 p-6 shadow-subtle hover:shadow-elevated transition-smooth"
        >
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground mb-1">
                {t(stat?.title)}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {stat?.value}
              </p>
              <div className="flex items-center mt-2">
                <Icon
                  name={stat?.changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'}
                  size={14}
                  className={stat?.changeType === 'positive' ? 'text-success' : 'text-error'}
                />
                <span
                  className={`text-xs font-medium ml-1 ${
                    stat?.changeType === 'positive' ? 'text-success' : 'text-error'
                  }`}
                >
                  {stat?.change}
                </span>
               
              </div>
            </div>
            <div className={`w-12 h-12 rounded-lg ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CouponStats;